const SELECTORS = {
  parent: ".site-search__form",
  active: ".bef-link--selected",
};

const CLASSES = {
  active: "tab-active",
  link: "link",
};

class SiteSearch {
  constructor(context) {
    this.context = context;
  }

  init() {
    this.setActiveTab();
  }

  setActiveTab() {
    $(`${SELECTORS.parent} ul > li:has(${SELECTORS.active})`).addClass(
      CLASSES.active,
    );
  }
}

export { SiteSearch };
